import React from 'react';
import { useTranslation } from "react-i18next";

interface APIErrorComponentProps {
    errorCount: number;
    customErrorMsg?: string | null;
}

const APIErrorComponent: React.FC<APIErrorComponentProps> = ({errorCount,customErrorMsg}) => {
   const { t } = useTranslation();
    return (
        <div className="pr-2 py-2 bg-red-20 flex items-center">
            <div className="px-2 pr-8">
                <i className="fas fa-exclamation-circle text-brick-100 w-6 h-6 bolder-font"></i>
            </div>
            <div className="flex items-center text-black">
                <p className="w-full text-left my-2">
                                <b>{customErrorMsg ?? (errorCount > 1 ? t("Api_Error_Msg3") : t("Api_Error_Msg1"))}</b>
                                {customErrorMsg ? <b>{t("Api_Error_Msg2")}</b> : t("Api_Error_Msg2")}
                </p>
            </div>
            
        </div>
    );
};
export default APIErrorComponent;